import {Observable} from 'rxjs/Rx';
import {AsynchronousDefinition} from '@ng-app-framework/validation';
export class EndpointValidator {
/**
 * @param {?=} input
 * @param {?=} output
 */
constructor(public input?: AsynchronousDefinition,
public output?: AsynchronousDefinition) {
    }
/**
 * @param {?} request
 * @return {?}
 */
validateRequest(request: any) {
        if (this.input) {
            return this.input.validate$(request);
        }
        return new Observable(observer => observer.complete());
    }
/**
 * @param {?} response
 * @return {?}
 */
validateResponse(response: any) {
        if (this.output) {
            return this.output.validate$(response).concat(Observable.from([response]));
        }
        return Observable.from([response]);
    }
}

function EndpointValidator_tsickle_Closure_declarations() {
/** @type {?} */
EndpointValidator.prototype.input;
/** @type {?} */
EndpointValidator.prototype.output;
}

